export default __webpack_public_path__ + "static/media/rc1.6caeba6e.jpg";